import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  chip: {
    margin: 0,
  },
  experimentalChip: {
    margin: 0,
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.getContrastText(theme.palette.warning.main),
  },
}));

export function TemplateCardTags({ tags }: { tags?: string[] }) {
  const classes = useStyles();
  if (!tags?.length) return null;
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          {tags.map(tag => (
            <Grid item key={tag}>
              <Chip
                className={tag === 'experimental' ? classes.experimentalChip : classes.chip}
                size="small"
                label={tag}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </>
  );
}
